import React, { useState } from "react";
import AppLayout from "@amzn/meridian/app-layout";
import { DocumentTitle } from "@/app/components/DocumentTitle";
import MastheadWrapper from "@/app/components/Masthead";
import SideMenuWrapper from "@/app/components/SideMenu";
import { RootRouter } from "@/app/routes/RootRouter";

const App: React.FC = () => {
  const [isMenuVisible, setIsMenuVisible] = useState<boolean>(true);

  return (
    <AppLayout
      headerComponent={MastheadWrapper}
      sidebarComponent={SideMenuWrapper}
      alwaysShowScrollbar={false}
    >
      <DocumentTitle />
      <MastheadWrapper onMenuClick={() => setIsMenuVisible((prev) => !prev)} />
      <SideMenuWrapper open={isMenuVisible} />
      <RootRouter />
    </AppLayout>
  );
};

export default App;
